import { createRoutine } from 'redux-saga-routines';

export const fetchInventoryAuditLogs = createRoutine(
  'FETCH_INVENTORY_AUDIT_LOGS'
);

export const fetchInventoryAuditLogsSearchOptions = createRoutine(
  'FETCH_INVENTORY_AUDIT_LOGS_SEARCH_OPTIONS'
);
